define('widgets/size',[
	'jquery',
	'lib/jquery-ui/widget'
], function ($) {

	var size = 1,
		max = 4,
		$body = $(document.body);

	return $.widget('muse.size', {

		options: {
		},

		_create: function () {

			this._on({
				'click a': $.proxy(this, 'onClick')
			});

			this.element.disableSelection();

			return this._super();

		},

		onClick: function (e) {

			var $el = $(e.currentTarget),
				val = size;

			val += ($el.hasClass('larger')) ? 1 : -1;
			val = Math.min(Math.max(val, 1), max);

			if (size == val) return;

			$body.removeClass('size-' + size)
				.addClass('size-' + val);

			size = val;

			$.publish('sizeUpdate');

		}

	});

});
